
export default {
  mounted (el, ops) {
    el.addEventListener('click', (e) => {
      e.stopPropagation()
      toRouter(ops.value)
    })
  }
}
